// extracted by mini-css-extract-plugin
export default {"layoutHeader":"Header_layoutHeader__FhHXE"};